import { render, staticRenderFns } from "./blcokspace.vue?vue&type=template&id=41e20492&scoped=true&"
import script from "./blcokspace.vue?vue&type=script&lang=js&"
export * from "./blcokspace.vue?vue&type=script&lang=js&"
import style0 from "./blcokspace.vue?vue&type=style&index=0&id=41e20492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e20492",
  null
  
)

export default component.exports